import * as actionTypes from "../action-types";

const initialState = {
    revenueSettings: null,
    revenueRecords: [],
    revenueSummary: {},
    revenueLoading: false,
};

const revenueReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_REVENUE_SETTINGS:
            return { ...state, revenueSettings: payload };

        case actionTypes.SET_REVENUE_RECORDS:
            return {
                ...state,
                revenueRecords: payload?.records || [],
                revenueSummary: payload?.summary || {},
                revenueLoading: false,
            };

        case actionTypes.GET_REVENUE_RECORDS:
            return { ...state, revenueLoading: true };

        default:
            return state;
    }
};

export default revenueReducer;
